import { useAtomValue } from 'jotai';
import { unitSystem as unitSystemState } from '@/components/Analysis/state';
import { UnitSystemEnum, UnitsEnum } from '@/__generated__/graphql';
import { MAX_BLISTER_HEIGHT_TEMPLATE_FIELD_KEY, conversionFields } from '@/constants';
import { useCallback } from 'react';

const unitSuffix = {
  [UnitsEnum.Meter]: {
    [UnitSystemEnum.Imperial]: 'ft',
    [UnitSystemEnum.Metric]: 'm',
  },
  [UnitsEnum.SquareMeter]: {
    [UnitSystemEnum.Imperial]: 'ft²',
    [UnitSystemEnum.Metric]: 'm²',
  },
  [UnitsEnum.Millimeter]: {
    [UnitSystemEnum.Imperial]: 'in',
    [UnitSystemEnum.Metric]: 'mm',
  },
};

const blisterHeightSuffix = {
  [UnitSystemEnum.Imperial]: 'in',
  [UnitSystemEnum.Metric]: 'mm',
};

type GetUnitSuffixType = { unit?: UnitsEnum | string | null; field?: string };

export const useUnitConversion = () => {
  const unitSystem = useAtomValue(unitSystemState);

  const getUnitSuffix = useCallback(
    ({ unit, field }: GetUnitSuffixType): string => {
      if (unit) return unitSuffix[unit as UnitsEnum]?.[unitSystem] || '';
      if (field === 'size') return 'in';
      if (field === MAX_BLISTER_HEIGHT_TEMPLATE_FIELD_KEY) return blisterHeightSuffix[unitSystem];

      const { unit: fieldUnit, isPercentage } = (field && conversionFields[field]) || {};
      return isPercentage
        ? '%'
        : fieldUnit
        ? unitSuffix[fieldUnit as UnitsEnum]?.[unitSystem] || ''
        : '';
    },
    [unitSystem]
  );

  return { getUnitSuffix };
};
